import React from "react";
import { useSchedules } from "../hooks/useSchedules";
import { PaymentsTable } from "../components/PaymentsTable";
import { useAgreementContext } from "../AgreementContext";
import { Stack } from "@mui/material";

const PaymentsPage = () => {
  const agreement = useAgreementContext();
  const schedules = useSchedules(agreement.id);
  const currentSchedule = schedules.schedules?.find(
    (schedule) => schedule.status === "open" || schedule.status === "settled"
  );
  return currentSchedule ? (
    <Stack spacing={5} sx={{ px: 5, mb: 5 }}>
      <PaymentsTable
        agreement={agreement}
        scheduleId={currentSchedule.id}
        schedules={schedules.schedules}
      />
    </Stack>
  ) : null;
};

export default PaymentsPage;
